import React from 'react'
import withServer from 'components/withServer'
import updateServerMutation from 'graphs/mutations/updateServer.graphql'
import serverValidation from 'validations/server'
import FormForRecord from 'components/FormForRecord'
import fields from 'fields/servers'

const RouteEdit = ({ server, history: { goBack } }) => (
  <FormForRecord
    record={server}
    mutation={updateServerMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={fields}
    variables={{ id: server.id }}
    schema={serverValidation}
    title="Edit Server Information"
  />
)

export default withServer(RouteEdit)



// WEBPACK FOOTER //
// ./src/routes/admin/servers/edit.js